import { HereResult } from '@user/store/services/hereGeoCoder'

export interface FormAddress {
  address1: string
  address2: string
  city: string
  state: string
  postalCode: string
  // TODO: What is this? Do we need it?
  county: string
  country: string
  lat: number
  lng: number
}

export const initialState: FormAddress = {
  address1: '',
  address2: '',
  city: '',
  country: '',
  lat: 0,
  lng: 0,
  postalCode: '',
  county: '',
  state: '',
}

export function formAddressToString(address: FormAddress): string {
  const { address1, address2, city, state, postalCode } = address
  return `${address1} ${address2} ${city} ${state} ${postalCode}`.trim()
}

export function isValidAddress(address: FormAddress): boolean {
  return (
    address &&
    address.address1?.trim().length > 0 &&
    address.city?.trim().length > 0 &&
    address.state?.trim().length > 0 &&
    address.postalCode?.trim().length > 0
  )
}

export function hereResultToFormAddress(place: HereResult): FormAddress {
  const {
    address: {
      houseNumber = '',
      street = '',
      city,
      stateCode: state,
      postalCode,
      county,
      countryCode: country,
    },
    position: { lat, lng },
  } = place

  return {
    address1: `${houseNumber} ${street}`.trim(),
    address2: '',
    city,
    state,
    postalCode,
    county,
    country,
    lat,
    lng,
  }
}
